import MarkdownIt from 'markdown-it';
const md = new MarkdownIt({
    html: false,
    linkify: true,
    typographer: true,
});
export function markdownToHtml(markdown) {
    if (!markdown) {
        return '';
    }
    return md.render(markdown);
}
//# sourceMappingURL=markdownToHtml.js.map